class ThreadHead
    constructor: (el) ->
        @.$el = el
        @.$answerButton = @.$el.querySelector '.thread-head__answer'
        @.$bookmarkButton = @.$el.querySelector '.thread-head__bookmark'
        @.$subscribeButton = @.$el.querySelector '.thread-head__subscribe'
        @.$titleEl = @.$el.querySelector '.thread-head__information__title'
        @.$topicButton = @.$el.querySelector '.thread-head__topic-button'

        @.answerOverlayId = @.$el.dataset?.answerOverlayId ? false
        @.api = @.$el.dataset?.api ? false
        @.apiMethod = @.$el.dataset?.apiMethod ? 'GET'
        @.forumId = @.$el.dataset?.forumId ? false
        @.forumLink = @.$el.dataset?.forumLink ? undefined
        @.forumTitle = @.$el.dataset?.forumTitle ? 'Forum'
        @.threadId = @.$el.dataset?.threadId ? undefined
        @.topicOverlayId = @.$el.dataset?.topicOverlayId ? false
        @.updateBreadcrumbs = @.$el.dataset?.ubc == 'true'
        @.writeAllowed = @.$el.dataset?.wa == 'true'

        @.$el.classList.add 'thread-head--bound'

        if !@.api && !@.threadId
            @.$subscribeButton.remove()

        @.InitEvents()
        if @.updateBreadcrumbs
            @.UpdateBreadcrumbs()
        return

    InitEvents: ->
        self = @
        if @.$answerButton && @.writeAllowed
            @.$answerButton.addEventListener 'click', (e) ->
                e.preventDefault()
                if self.answerOverlayId
                    answerOverlayEl = document.getElementById self.answerOverlayId
                    if answerOverlayEl
                        answerOverlayEl.dispatchEvent new CustomEvent 'overlay-show', { bubbles: false }
                        openAnswerOverlayEl = document.getElementById "overlay-id_#{ self.answerOverlayId }"
                        if openAnswerOverlayEl
                            addEntryPostEl = openAnswerOverlayEl.querySelector '.add-entry--post'
                            if addEntryPostEl && typeof self.threadId != 'undefined'
                                addEntryPostEl.dispatchEvent new CustomEvent 'add-entry-set-topic-id', {
                                    bubbles: false
                                    detail: {
                                        topicId: self.threadId
                                    }
                                }
                return
        if @.$bookmarkButton
            @.$bookmarkButton.addEventListener 'click', (e) ->
                e.preventDefault()
                @.classList.toggle 'thread-head__bookmark--active'
                @.querySelector '.button__text'
                    .textContent = if @.classList.contains('thread-head__bookmark--active') then @.dataset.bookmarked else @.dataset.bookmark
                return
        if @.$subscribeButton
            @.$subscribeButton.addEventListener 'click', (e) ->
                e.preventDefault()
                self.ToggleSubscribeButton()
                self.SendSubscriction !@.classList.contains('thread-head__subscribed--active')
                return
        if @.$topicButton && @.topicOverlayId
            @.$topicButton.addEventListener 'click', (e) ->
                topicOverlayEl = document.getElementById self.topicOverlayId
                if topicOverlayEl
                    topicOverlayEl.dispatchEvent new CustomEvent 'overlay-show', { bubbles: false }
                    openTopicOverlayEl = document.getElementById "overlay-id_#{ self.topicOverlayId }"
                    if openTopicOverlayEl
                        addEntryTopicEl = openTopicOverlayEl.querySelector '.add-entry--topic'
                        if addEntryTopicEl && typeof self.forumId != 'undefined'
                            addEntryTopicEl.dispatchEvent new CustomEvent 'add-entry-set-forum-id', {
                                bubbles: false
                                detail: {
                                    forumId: self.forumId
                                }
                            }
                return
        else
            if @.$topicButton
                @.$topicButton.remove()
        return
    
    SendSubscriction: (unsubscribe) ->
        if @.api && @.apiMethod
            self = @
            try
                if @.apiMethod == 'POST'
                    body = {
                        threadId: self.threadId
                        unsubscribe: unsubscribe ? false
                    }
                    request = window.appUtils.XMLHttpRequest @.apiMethod, @.api
                        , ->
                            if request.responseText && request.responseText != ""
                                try
                                    answer = JSON.parse request.responseText
                                    console.log answer
                                    if !answer.success
                                        console.log answer.message
                                        self.ToggleSubscribeButton()
                                catch error
                                    console.log "Fehler beim Versuch die Antwort der Schnittstelle zum Abonnieren eines Themas zu verarbeiten"
                                    self.ToggleSubscribeButton()
                                    return
                            else
                                console.log "Die Anfrage an die Schnittstelle zum Abonnieren eines Themas lieferte ein leeres Ergebnis"
                                self.ToggleSubscribeButton()
                        , ->
                            console.log "Bei der Anfrage an die Schnittstelle zum Abonnieren eines Themas ist leider ein Fehler aufgetreten"
                            self.ToggleSubscribeButton()
                            return
                        , if self.apiMethod == 'POST' then JSON.stringify(body) else {}
            catch error
                console.log "Fehler beim Versuch die Schnittstelle zum Abonnieren eines zu ermitteln."
                self.ToggleSubscribeButton()
        return
    
    ToggleSubscribeButton: ->
        if @.$subscribeButton
            @.$subscribeButton.classList.toggle 'thread-head__subscribed--active'
            @.$subscribeButton.querySelector '.button__text'
                .textContent = if @.$subscribeButton.classList.contains('thread-head__subscribed--active') then @.$subscribeButton.dataset.subscribed else @.$subscribeButton.dataset.subscribe
        return
    
    UpdateBreadcrumbs: ->
        if @.updateBreadcrumbs && @.$titleEl
            self = @
            document.querySelectorAll '.breadcrumbs--bound'
                .forEach (bcEl) ->
                    bcEl.dispatchEvent new CustomEvent 'breadcrumbs-add', {
                        bubbles: false,
                        detail: {
                            items: [
                                {
                                    link: self.forumLink ? '#',
                                    text: self.forumTitle
                                },
                                {
                                    link: window.location.href,
                                    text: self.$titleEl.textContent
                                }
                            ]
                        }
                    }
                    return
        return

BindThreadHeads = ->
    document.querySelectorAll '.thread-head:not(.thread-head--bound)'
        .forEach (el) ->
            new ThreadHead el
            return
    return

window.addEventListener 'bind-components', BindThreadHeads